<template>
  <div class="teaching-schedule-query-teacher-arrange">
    <PlatDataPanelSelect custom-type="arrange"
                         :custom-id="customId"
                         :data-types="['semester']"
                         :border="false"
                         semesterLabel="选择学期">
      <template #default="scope">
        <TeachingScheduleQueryTeacherArrangeMain :key="scope.semester"
                                                 :teacher-id="rowData.id"
                                                 :extra-params="scope"
                                                 v-bind="$attrs"></TeachingScheduleQueryTeacherArrangeMain>
      </template>
      <template #extra="scope">
        <action-form :action="$contextPath('/workspace/manager/teaching/schedule/query/teacher/exportArrange')"
                     :pre-handle-params="paramResolver"
                     :form-params="scope"
                     target="_blank">
          <template #default="{submit}">
            <el-button size="mini"
                       type="primary"
                       plain
                       @click="submit">导出教师课表</el-button>
          </template>
        </action-form>
      </template>
    </PlatDataPanelSelect>
  </div>
</template>

<script>
import PlatDataPanelSelect from '../../../../../wrapper/panel/PlatDataPanelSelect'
import TeachingScheduleQueryTeacherArrangeMain from './main'
import routeConfig from '../../../../../../../../../constants/routeConfig'
export default {
  name: 'TeachingScheduleQueryTeacherArrange',
  components: {
    PlatDataPanelSelect,
    TeachingScheduleQueryTeacherArrangeMain
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      customId: ''
    }
  },
  methods: {
    paramResolver () {
      return {
        postId: this.rowData.id
      }
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataGrid.param]
  }
}
</script>

<style lang="scss">
  .teaching-schedule-query-teacher-arrange {
    height: 100%;
  }
</style>
